import { PaymentStatus } from "@/shared/enums/status.enum";
import type { Payment } from "@/payments/types/payments";

export const getPaymentRefundStatus = (
  payment: Payment | null | undefined,
): PaymentStatus | null => {
  const latestCharge =
    payment?.latest_charge && typeof payment.latest_charge === "object"
      ? payment.latest_charge
      : null;
  const refundedAmount = latestCharge?.amount_refunded;
  const paymentAmount = payment?.amount;

  if (
    typeof refundedAmount !== "number" ||
    refundedAmount <= 0 ||
    typeof paymentAmount !== "number" ||
    paymentAmount <= 0
  ) {
    return null;
  }

  if (refundedAmount === paymentAmount) {
    return PaymentStatus.REFUNDED;
  }

  if (refundedAmount < paymentAmount) {
    return PaymentStatus.PARTIALLY_REFUNDED;
  }

  return null;
};

export const getPaymentDisplayStatus = (
  payment: Payment | null | undefined,
): string | null | undefined => getPaymentRefundStatus(payment) ?? payment?.status;

export const getPaymentDisplayAmount = (payment: Payment | null | undefined): number | undefined =>
  payment?.status === PaymentStatus.REQUIRES_CAPTURE ? payment.amount_capturable : payment?.amount;

export const getPaymentCaptureBefore = (
  payment: Payment | null | undefined,
): number | undefined => {
  const charge = payment?.latest_charge;
  const details = charge && typeof charge === "object" ? charge.payment_method_details : undefined;
  return details?.card?.moto === true
    ? details.card.capture_before
    : details?.card_present?.capture_before;
};

export const formatPaymentCaptureBefore = (timestamp: number | undefined): string | undefined => {
  if (!timestamp || !Number.isFinite(timestamp)) return undefined;
  const date = new Date(timestamp * 1000);
  if (Number.isNaN(date.getTime())) return undefined;
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(date);
};
